import api from '@/plugins/api'
import requestValidation from '@/configs/requestValidation'
import { measurement, headersMeasurement } from '@/configs/endpoints'
import { generateFilterParams } from '@/configs/helpers'

const store = 'stands'

export default {
  state: () => ({
    stands: [],
    standsOffline: [],
    currentStand: {},
    isLoad: false
  }),
  actions: {
    async getStands (context, filter) {
      context.commit('SET_DATA', { store, state: 'isLoad', data: true })
      const mock = {
        count: null,
        next: null,
        previous: null,
        results: []
      }
      const response = await api.get(measurement.stands + generateFilterParams(filter), headersMeasurement)
      if (await requestValidation(response)) {
        mock.results = response.data.stands
        context.commit('SET_DATA', { store, state: 'stands', data: mock })
      }
      context.commit('SET_DATA', { store, state: 'isLoad', data: false })
      return response.data.stands
    },
    async getStandsOffline (context, filter) {
      context.commit('SET_DATA', { store, state: 'isLoad', data: true })
      const mock = {
        count: null,
        next: null,
        previous: null,
        results: []
      }
      const response = await api.get(measurement.standsOffline + generateFilterParams(filter), headersMeasurement)
      if (await requestValidation(response)) {
        mock.results = response.data
        context.commit('SET_DATA', { store, state: 'standsOffline', data: mock })
      }
      context.commit('SET_DATA', { store, state: 'isLoad', data: false })
      return response.data
    },
    async getStand (context, id) {
      context.commit('SET_DATA', { store, state: 'isLoad', data: true })
      const response = await api.get(measurement.stand(id), headersMeasurement)
      if (await requestValidation(response)) {
        context.commit('SET_DATA', { store, state: 'currentStand', data: response.data[0] })
      }
      context.commit('SET_DATA', { store, state: 'isLoad', data: false })
      return response.data
    },
    async getStandCharacteristics (context, id) {
      const response = await api.get(measurement.standCharacteristics(id), headersMeasurement)
      if (await requestValidation(response)) return response.data
    },
    async saveStandCharacteristics (context, body) {
      const response = await api.post(measurement.standCharacteristicsSave, {
        ...headersMeasurement,
        body
      })
      if (await requestValidation(response)) return response.data
    },
    async saveStandInfo (context, body) {
      const response = await api.put(measurement.standInfo, {
        ...headersMeasurement,
        body
      })
      if (await requestValidation(response)) return response.data.result
    },
    async checkStandConnect (context, id) {
      const response = await api.get(measurement.standCheckConnect(id), headersMeasurement)
      if (await requestValidation(response)) return response.data.result
    },
    async standReboot (context, id) {
      const response = await api.get(measurement.standReboot(id), headersMeasurement)
      if (await requestValidation(response)) return response.data
    },
    async calibrationWeight (context, body) {
      const response = await api.post(measurement.calibrationWeight, {
        ...headersMeasurement,
        body
      })
      if (await requestValidation(response)) return response.data
    },
    async calibrationSensors (context, body) {
      const response = await api.post(measurement.calibrationBrake, {
        ...headersMeasurement,
        body
      })
      if (await requestValidation(response)) return response.data
    },
    async standDeparture (context, id) {
      const response = await api.get(measurement.measurementDeparture(id), headersMeasurement)
      if (await requestValidation(response)) return response.data
    },
    async createDeclaration (context, body) {
      const response = await api.post(measurement.createMeasurementDeclaration, {
        ...headersMeasurement,
        body
      })
      if (await requestValidation(response)) {
        return response.data
      }
    },
    async getArduinoLogs (context, id) {
      const response = await api.get(measurement.arduinoLogs(id), headersMeasurement)
      if (await requestValidation(response)) return response.data.arduino_logs
    },
    async standConnect (context, body) {
      const response = await api.get(measurement.standConnect(body.id, body.type), headersMeasurement)
      if (await requestValidation(response)) {
        if (response.data.status === 'free') {
          context.commit('SET_DATA', {store: 'measurement', state: 'standStatus', data: 'standConnect'})
        }
      }
      return response.data
    },
    async getAnalyzerType (context, body) {
      const params = new URLSearchParams()
      params.append('stand_serial', body.id)
      const response = await api.get(`${measurement.standAnalyzerType(body.type)}?${params}` , headersMeasurement)
      if (await requestValidation(response)) return response.data
    },
    async postAnalyzerType (context, body) {
      const response = await api.post(measurement.standAnalyzerType(body.type), {
        ...headersMeasurement,
        body: {
          model_name: body.name,
          stand_serial: body.id
        }
      })
      if (await requestValidation(response)) return response.data
    },
    async occupyStand (context, id) {
      const response = await api.get(measurement.occupyStand(id), {...headersMeasurement})
      return await requestValidation(response)
    },
    async turnOffTheStand (context, id) {
      const response = await api.get(measurement.turnOffTheStand(id), {...headersMeasurement})
      return await requestValidation(response)
    }
  },
  getters: {

  }
}
